import { Button, Modal } from '../../../../components'
import { DeleteUserI } from './type'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { deleteUsersList } from '../../pages/slice'
import { deleteUser } from '../../api'

const DeleteUser = ({ show, onClose, id }: DeleteUserI) => {
    // const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDeleteUser = async () => {
        const requestBody = {
            userId: id as string,
        }
        dispatch(SHOW_LOADER())
        try {
            const response = await deleteUser(requestBody)
            if (response.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'User deleted successfully',
                        type: 'success',
                    })
                )
                dispatch(deleteUsersList(requestBody?.userId))
            }
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
            onClose(false)
        }
    }

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={'Delete User'}
            body={
                <>
                    <p className="del-desc">
                        {'Are you sure you want to delete this user?'}
                    </p>
                    <p className="del-note">
                        {
                            'Note: All data associated with this user will be permanently lost.'
                        }
                    </p>

                    <div className="footer-block">
                        <Button type="submit" onClick={handleDeleteUser}>
                            YES
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DeleteUser
